import React from 'react';
import { getAvailablePlatforms, getAvailableRegions, getAvailableTypes } from '../configs';

const ToolBar = ({
  platform,
  region,
  type,
  onPlatformChange,
  onRegionChange,
  onTypeChange,
}) => {
  const platforms = getAvailablePlatforms();
  const regions = getAvailableRegions(platform);
  const types = getAvailableTypes(platform, region);

  return (
    <section id="tool-bar">
      <div className="tool-group">
        <label htmlFor="platform-select">Platform:</label>
        <select
          id="platform-select"
          value={platform}
          onChange={onPlatformChange}
        >
          {platforms.map(p => (
            <option key={p} value={p}>{p}</option>
          ))}
        </select>
      </div>

      <div className="tool-group">
        <label htmlFor="region-select">Region:</label>
        <select
          id="region-select"
          value={region}
          onChange={onRegionChange}
          disabled={!regions.length}
        >
          {regions.map(r => (
            <option key={r} value={r}>{r}</option>
          ))}
        </select>
      </div>

      <div className="tool-group">
        <label htmlFor="type-select">Layout:</label>
        <select
          id="type-select"
          value={type}
          onChange={onTypeChange}
          disabled={!types.length}
        >
          {types.map(t => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>
      </div>
    </section>
  );
};

export default ToolBar;
